import { Resource } from 'i18next';

import translationEn from './en/translation.json';
import translationPl from './pl/translation.json';
import translationNo from './no/translation.json';
import translationEs from './es/translation.json';

import { LANGUAGES } from '../consts';

const formLocales: Record<(typeof LANGUAGES)[number], Resource> = {
	en: translationEn,
	pl: translationPl,
	no: translationNo,
	es: translationEs,
};

export { formLocales };
